import { ValidationResult } from '../interfaces/validation-result';
import { i18n, I18nUtil } from '../utils/i18n-util';
import { EmailUtil } from '../utils/email-util';

export let textValidationRules = {
  i18n: i18n,
  validateMaxTextLength: function validateMaxTextLength(input: string, maxLength: number, context: any): ValidationResult {
    let result: ValidationResult = {
      isValid: input.length <= maxLength
    };
    if (!result.isValid) {
      result.errorMessage = this.i18n.getText('cu|validation engine|The text must have xx or less characters.', { maxLength: maxLength });
    }
    return result;
  },
  validateMinTextLength: function validateMinTextLength(input: string, minLength: number, context: any): ValidationResult {
    let result: ValidationResult = {
      isValid: input.length >= minLength
    };
    if (!result.isValid) {
      result.errorMessage = this.i18n.getText('cu|validation engine|The text must have xx or more characters.', {minLength: minLength});
    }
    return result;
  },
  validateExcludeChars: function validateExcludeChars(
    input: string,
    condition: { pattern: RegExp; excludeChars: string },
    context: any
  ): ValidationResult {
    //console.log('validating excludeChars');

    let result: ValidationResult = {
      isValid: !condition.pattern.test(input)
    };

    if (!result.isValid) {
      result.errorMessage = this.i18n.getText('cu|validation engine|Must not contain any characters in xx', { excludeChars: condition.excludeChars });
    }
    //console.log('result: ' + result.isValid);
    return result;
  },
  validateRegex: function validateRegex(
    input: string,
    condition: { pattern: RegExp; errorMessage: string },
    context: any
  ): ValidationResult {
    let result: ValidationResult = {
      isValid: condition.pattern.test(input)
    };

    if (!result.isValid) {
      result.errorMessage = condition.errorMessage;
    }
    return result;
  },
  validateInverseRegex: function validateInverseRegex(
    input: string,
    condition: { pattern: RegExp; errorMessage: string },
    context: any
  ): ValidationResult {
    let result: ValidationResult = {
      isValid: !condition.pattern.test(input)
    };

    if (!result.isValid) {
      result.errorMessage = condition.errorMessage;
    }
    return result;
  },
  validateEmail: function(input: string, condition: any, context: any): ValidationResult {
    let result: ValidationResult = {
      isValid: EmailUtil.validateEmail(input)
    };
    if (!result.isValid) {
      result.errorMessage = this.i18n.getText('cu|validation engine|The email is not in the correct format.');
    }
    return result;
  }
};
